<template>
  <v-container id="contact-grid" grid-list-xl>
    <section class="ftco-section">
      <div class="row justify-content-center">
        <div class="col-md-12 col-lg-10">
          <div class="wrap d-md-flex">
            <div class="img" id="img-block"></div>
            <v-card class="px-4">
              <v-card-title class="w-100 card-title mb-2 justify-center">
                {{ $t("register_title") }}
              </v-card-title>
              <v-card-title class="w-100 card-title mb-2 justify-center">
                <div
                  v-if="errors['connexion']"
                  class="text-danger text-sm-body-2"
                >
                  <span>{{ errors["connexion"][langLocal] }}</span>
                </div>
              </v-card-title>
              <v-card-text>
                <v-form class="mb-5">
                  <v-row>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        v-model="firstName"
                        :error-messages="firstNameErrors"
                        @blur="$v.firstName.$touch()"
                        :label="$t('firstName')"
                        minlength="3"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        v-model="lastName"
                        @keyup="uppercase"
                        :error-messages="lastNameErrors"
                        @blur="$v.lastName.$touch()"
                        :label="$t('lastName')"
                        minlength="3"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="email"
                        :error-messages="emailErrors"
                        @blur="$v.email.$touch()"
                        label="Email"
                        required
                      ></v-text-field>
                      <div
                        v-if="errors['email']"
                        class="text-danger text-sm-body-2"
                      >
                        <span>{{ errors["email"][langLocal] }}</span>
                      </div>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        block
                        required
                        v-model="verify_email"
                        label="Confirmation Email"
                        :error-messages="emailVerifyErrors"
                        @blur="$v.verify_email.$touch()"
                      ></v-text-field>
                      <div
                        v-if="errors['email']"
                        class="text-danger text-sm-body-2"
                      >
                        <span>{{ errors["email"][langLocal] }}</span>
                      </div>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="password"
                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                        :error-messages="passwordErrors"
                        @blur="$v.password.$touch()"
                        :type="show1 ? 'text' : 'password'"
                        name="password"
                        :label="$t('password')"
                        :hint="$t('minCaracter')"
                        counter
                        @click:append="show1 = !show1"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        block
                        v-model="verify"
                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="show1 ? 'text' : 'password'"
                        name="passwordconfirm"
                        :label="$t('password_confirm')"
                        counter
                        @click:append="show1 = !show1"
                        :error-messages="verifyErrors"
                        @blur="$v.verify.$touch()"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-checkbox
                        required
                        color="warning"
                        :error-messages="checkboxErrors"
                        @change="$v.checkbox.$touch()"
                        v-model="checkbox"
                      >
                        <template v-slot:label>
                          <div @click.stop="">
                            {{ $t("agree") }}
                            <a href="#" @click.prevent="terms = true">terms</a>
                            &
                            <a href="#" @click.prevent="conditions = true"
                              >conditions?</a
                            >
                          </div>
                        </template>
                      </v-checkbox>
                    </v-col>
                    <v-col class="d-flex ml-auto" cols="12" sm="12" xsm="12">
                      <v-btn color="warning" small fab to="/login">
                        <v-icon>mdi-arrow-left</v-icon>
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-spacer></v-spacer>
                      <v-spacer></v-spacer>
                      <v-spacer></v-spacer>
                      <v-btn
                        class="mx-2 my-2"
                        color="warning"
                        @click="submit"
                        :loading="isLoading"
                        :disabled="this.$v.$invalid"
                      >
                        {{ $t("register_btn") }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
            </v-card>
          </div>
        </div>
      </div>
    </section>
    <v-container row justify-center align-center class="mx-auto mt-4 pt-2 m-0">
      <v-dialog v-model="terms" width="70%" style="z-index: 1500">
        <v-card>
          <v-card-title class="text-h6"> Terms </v-card-title>
          <v-card-text v-for="n in 5" :key="n">
            {{ content }}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="purple" @click="terms = false"> Ok </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="conditions" width="70%" style="z-index: 1500">
        <v-card>
          <v-card-title class="text-h6"> Conditions </v-card-title>
          <v-card-text v-for="n in 5" :key="n">
            {{ content }}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="purple" @click="conditions = false"> Ok </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-container>
</template>

<script>
import img from "../../public/african.jpeg";
import { validationMixin } from "vuelidate";
import { mapGetters } from "vuex";
import {
  required,
  email,
  minLength,
  sameAs,
  helpers,
} from "vuelidate/lib/validators";
const nameRegex = helpers.regex(
  "alphaNum",
  /^[\w'\-,.][^0-9_!¡?÷?¿/\\+=@#$%ˆ&*(){}|~<>;:[\]]{2,}$/
);

export default {
  name: "Register",
  mixins: [validationMixin],
  validations: {
    email: { required, email },
    password: { required, minLength: minLength(8) },
    firstName: { required, nameRegex },
    lastName: { required, nameRegex },
    checkbox: { required, sameAs: sameAs(() => true) }, // add this line in validation},
    verify: {
      required,
      sameAs: sameAs(function () {
        return this.password;
      }),
    },
    verify_email: {
      required,
      sameAs: sameAs(function () {
        return this.email;
      }),
    },
  },
  created() {
    this.$store.dispatch("setCurrentRoute", this.$route.name);

    this.$root.$i18n.locale = this.langLocal;
  },
  data() {
    return {
      checkbox: null,
      isLoading: false,
      label: "Enregistrement en cours",
      show1: false,
      img_log: img,
      email: "",
      password: "",
      verify: "",
      verify_email: "",
      firstName: "",
      lastName: "",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam. Sed nisi. Nulla quis sem at nibh elementum imperdiet. Duis sagittis ipsum. Praesent mauris. Fusce nec tellus sed augue semper porta. Mauris massa. Vestibulum lacinia arcu eget nulla. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Curabitur sodales ligula in libero. Sed dignissim lacinia nunc.",
      terms: false,
      conditions: false,
    };
  },
  watch: {
    checkbox(val) {
      // console.log(val)
      // this.$v.$touch()
      // console.log(this.$v.$invalid)
    },
    registered(value, oldvalue) {
      if (value === true) {
        this.$router.push("/confirm");
        this.$store.dispatch("clear");
      }
    },
    show(value, oldvalue) {
      setTimeout(() => {
        this.show = false;
      }, 2000);
    },
    email() {
      this.$store.dispatch("clear");
    },
    password() {
      this.$store.dispatch("clear");
    },
    email() {
      this.$store.dispatch("clear");
    },
    firstName() {
      this.$store.dispatch("clear");
    },
    lastName() {
      this.$store.dispatch("clear");
    },
    verify() {
      this.$store.dispatch("clear");
    },
    verify_email() {
      this.$store.dispatch("clear");
    },
  },
  methods: {
    uppercase() {
      this.lastName = this.lastName.toUpperCase();
    },

    async submit() {
      this.isLoading = true;
      this.$v.$touch();
      const data = new FormData();
      data.append("prenom", this.firstName);
      data.append("nom", this.lastName);
      data.append("email", this.email);
      data.append("password", this.password);
      data.append("password_confirmation", this.verify);
      data.append("langue", this.langLocal);
      if (!this.$v.$invalid) {
        await this.$store
          .dispatch("register", data)
          .then((response) => {
            this.isLoading = false;
          })
          .catch((error) => {
            this.loading = false;
            console.error(error);
          });
      }
    },
  },
  beforeCreate() {
    this.isLoading = false;
    this.$store.dispatch("clear");
  },
  computed: {
    getLocaleMessages() {
      return this.$root.$i18n.messages[this.$root.$i18n.locale];
    },
    verifyErrors() {
      const errors = [];
      if (!this.$v.verify.$dirty) return errors;
      !this.$v.verify.required &&
        errors.push(this.getLocaleMessages["required_confirm_password"]);
      if (this.password != this.verify)
        errors.push(this.getLocaleMessages["match_password"]);
      return errors;
    },

    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      if (!this.$v.password.minLength)
        errors.push(this.getLocaleMessages["min_password"]);
      !this.$v.password.required &&
        errors.push(this.getLocaleMessages["required_password"]);
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.required &&
        errors.push(this.getLocaleMessages["valid_email"]);
      !this.$v.email.required &&
        errors.push(this.getLocaleMessages["required_email"]);
      return errors;
    },
    emailVerifyErrors() {
      const errors = [];
      if (!this.$v.verify_email.$dirty) return errors;
      !this.$v.verify_email.required &&
        errors.push(this.getLocaleMessages["required_confirm_password"]);
      if (this.email != this.verify_email)
        errors.push(this.getLocaleMessages["required_confirm_email"]);
      return errors;
    },
    firstNameErrors() {
      const errors = [];
      if (!this.$v.firstName.$dirty) return errors;
      !this.$v.firstName.required &&
        errors.push(this.getLocaleMessages["required_firstname"]);
      !this.$v.firstName.nameRegex &&
        errors.push(this.getLocaleMessages["caracter_firstname"]);
      return errors;
    },
    lastNameErrors() {
      const errors = [];
      if (!this.$v.lastName.$dirty) return errors;
      !this.$v.lastName.required &&
        errors.push(this.getLocaleMessages["required_lastname"]);
      !this.$v.lastName.nameRegex &&
        errors.push(this.getLocaleMessages["caracter_lastname"]);
      return errors;
    },
    checkboxErrors() {
      const errors = [];
      if (!this.$v.checkbox.$dirty) return errors;
      !this.$v.checkbox.required &&
        errors.push(this.getLocaleMessages["required_checkbox"]);
      !this.$v.checkbox.sameAs &&
        errors.push(this.getLocaleMessages["required_checkbox"]);

      return errors;
    },
    ...mapGetters([
      "current_route",
      "registered",
      "loading",
      "errors",
      "langLocal",
    ]),
  },
};
</script>

<style scoped>
@import "../../public/assets/css/style.css";

#contact-grid {
  width: 100%;
}
#img-block {
  background-image: url("../../public/african.jpeg");
}
.mobile-position {
  margin: 10px;
}
.card-title {
  color: rgb(63, 53, 99);
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}
.w3l-footer {
  position: fixed;
  left: 0px;
  bottom: 0px;
  z-index: 100;
  width: 100%;
}

@media (max-width: 700px) {
  #img-block {
    display: none;
  }
  .login-wrap {
    min-height: 60vh;
  }
}
</style>
